import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import {LangController} from "../../../components/tabs/langController";

const CategoryLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder},
            name: '',
            twoLetterCode: '',
            description: '',
            callToActionUrl:'',
            callToActionLabel:''
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"10"}>
                <FormGroup>
                    <Label>{'Nombre' }</Label>
                    <Input
                        type="text"
                        name="name"
                        value= { child.name }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"2"}>
                <FormGroup>
                    <Label>{'Codigo'}</Label>
                    <Input
                        type="text"
                        name={"twoLetterCode"}
                        value= { child.twoLetterCode }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md="4">
                <FormGroup>
                    <Label>{'Etiqueta (CTA)'}</Label>
                    <Input type="text"
                           name="callToActionLabel"
                           placeholder="Ingrese el texto del botón de acción"
                           value={child.callToActionLabel}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="8">
                <FormGroup>
                    <Label>{'URL (CTA)'}</Label>
                    <Input type="text"
                           name="callToActionUrl"
                           placeholder="Ingrese la url del boón de acción"
                           value={child.callToActionUrl}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{'Descripción'}</Label>
                    <Input
                        type={"textarea"}
                        rows={5}
                        name={"description"}
                        value= { child.description }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default CategoryLangs
